import React from 'react';
import { Col } from 'react-bootstrap';
import styled from 'styled-components';

const InfoContainerLabel = styled.div`
  color: #3a3a3a;
  border-bottom: 1px solid #999;
  text-transform: capitalize;
  font-weight: 600;
`

const InfoContainerValue = styled.div`
  text-align: right;
  line-height: 28px;
  min-height: 28px;
`

const InfoContainer = ({label, value, size=3}) => {
  return (<Col xs={size}>
    <InfoContainerLabel>{label}</InfoContainerLabel>
    <InfoContainerValue>{value}</InfoContainerValue>
  </Col>)
}

export default InfoContainer